var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',[_c('b-dropdown-divider'),_c('b-dropdown-item',{on:{"click":_vm.getPreImports}},[_c('i',{staticClass:"icon-eye"}),_vm._v(" Pre Importaciones ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }